
enum constants{
    visitIdKey = 'visitIdKey',
    verifyOTPKey = 'verifyOTPKey',
    visitId='visitId',
    phoneNumber='phoneNumber'
}

export default constants;